(function (upp) {
    'use strict';

    upp.service('analytics', ['$http', 'device', 'config',
        function ($http, device, config) {

            var sessionId,
                SERVICE = $UPP.URL_ANALYTICS_REST_SERVICE;

            /**
             * Invoke the analytics API REST server to register new connection, and store the session id returned by the service
             * @method registerNewConnection
             */
            var registerNewConnection = function () {
                if (!sessionId) {
                    config.getChilduppId().then(function (id) {
                        $http.post(SERVICE + "connection/in/", {
                            device : {
                                id : device.getDeviceId(),
                                app : device.inPhonegap(),
                                os : device.getOsName() ? {
                                    name : device.getOsName()
                                } : undefined
                            }
                        }, {
                            headers : {
                                'ChildUpp' : id
                            }
                        }).success(function (data) {
                            sessionId = data.sessionId;
                        });
                    });
                }
            };

            /**
             * Returns if the session is registered
             * @method {Boolean} isSessionRegistered
             * @return {Boolean} Returns true if session is registered
             */
            var isSessionRegistered = function () {
                return typeof sessionId !== 'undefined';
            };

            return {
                registerNewConnection : registerNewConnection,
                isSessionRegistered : isSessionRegistered
            }

        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/common/services/analytics-service.js